export const isIphoneChrome = () => {
  const ua = navigator.userAgent;

  return /iPhone/i.test(ua) && /CriOS/i.test(ua);
};


